import KoreanLunarCalendar from 'korean-lunar-calendar'

const WEEKDAYS = ['일', '월', '화', '수', '목', '금', '토']

export function toDateKey(date: Date): string {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export function fromDateKey(value: string): Date {
  const [year, month, day] = value.split('-').map(Number)
  return new Date(year, month - 1, day)
}

export function formatFullDate(date: Date): string {
  return `${date.getMonth() + 1}월 ${date.getDate()}일 ${WEEKDAYS[date.getDay()]}요일`
}

export function formatMonthTitle(date: Date): string {
  return `${date.getFullYear()}년 ${date.getMonth() + 1}월`
}

export function getLunarLabel(date: Date): string {
  const lunar = getLunarDate(date)
  if (!lunar) return '음력 범위 밖'
  return `음력 ${lunar.month}월 ${lunar.day}일${lunar.intercalation ? ' (윤달)' : ''}`
}

export function getLunarDate(date: Date): { month: number; day: number; intercalation: boolean } | null {
  const calendar = new KoreanLunarCalendar()
  const valid = calendar.setSolarDate(date.getFullYear(), date.getMonth() + 1, date.getDate())
  if (!valid) return null

  const lunar = calendar.getLunarCalendar()
  return { month: lunar.month, day: lunar.day, intercalation: Boolean(lunar.intercalation) }
}

export function getCalendarDays(viewDate: Date): Date[] {
  const first = new Date(viewDate.getFullYear(), viewDate.getMonth(), 1)
  const start = new Date(first)
  start.setDate(first.getDate() - first.getDay())

  return Array.from({ length: 42 }, (_, index) => {
    const date = new Date(start)
    date.setDate(start.getDate() + index)
    return date
  })
}

export function shiftMonth(date: Date, amount: number): Date {
  return new Date(date.getFullYear(), date.getMonth() + amount, 1)
}

export function isSameDay(left: Date, right: Date): boolean {
  return toDateKey(left) === toDateKey(right)
}
